/* global Sys, Services, Core */
Sys.ns("Services");

/**
 * @typedef {Object} ILoadingProgressData
 * @property {number} recources
 * @property {number} count
 */

Services.IntegrationLoadProgress = {
    EVENT: {
        LOADING_PROGRESS: "LOADING_PROGRESS"
    },
    POST_MESSAGE_TARGET: "*",
    MESSAGE_INTERVAL: 500,

    /**
     * Calculate count and transfer size of downloaded resources from Performance API.
     *
     * @private
     * @returns {ILoadingProgressData} Loading progress information.
     */
    calcLoadingProgress: function() {
        var resources = [],
            result,
            i;

        if (window.performance && window.performance.getEntriesByType) {
            resources = window.performance.getEntriesByType("resource");
        }

        result = { transfer: 0, count: 0 };

        for (i = 0; i < resources.length; i++) {
            result.transfer += resources[i].transferSize || 0;
            result.count++;
        }

        return result;
    },

    /**
     * Start reporting information about loading progress.
     *
     * @private
     * @param {Object} operatorWindow Operator window.
     * @returns {number} Interval id.
     */
    setReportingInterval: function(operatorWindow) {
        var me = this;

        return window.setInterval(function() {
            operatorWindow.postMessage(
                {
                    type: me.EVENT.LOADING_PROGRESS,
                    data: me.calcLoadingProgress()
                },
                me.POST_MESSAGE_TARGET
            );
        }, me.MESSAGE_INTERVAL);
    },

    /**
     * Clear interval when loading progress handler reach 100%.
     *
     * @private
     * @param {number} progressIntervalId Id of interval to clear.
     * @param {Object} loadProgressHandler LoadProgressHandler class instance.
     * @returns {void}
     */
    clearReportingIntervalOnLoadingComplete: function(progressIntervalId, loadProgressHandler) {
        loadProgressHandler.on(
            Core.LoadProgressEvents.PROGRESS,
            function() {
                clearInterval(progressIntervalId);
            },
            function(progress) {
                return progress >= 100;
            }
        );
    },

    /**
     * Start reporting interval and clear it when finished loading process.
     *
     * @public
     * @param {Object} loadProgressHandler LoadProgressHandler class instance.
     * @returns {void}
     */
    startReporting: function(loadProgressHandler) {
        var progressIntervalId,
            operatorWindow = Core.messageApi.getIFrameWindow();

        if (!operatorWindow) {
            return;
        }

        progressIntervalId = this.setReportingInterval(operatorWindow);

        this.clearReportingIntervalOnLoadingComplete(
            progressIntervalId,
            loadProgressHandler
        );
    }
};
